import Form from './components/FormWrapper';
import DigiForm, { Profile } from './digiForm';
export default { Form: Form, DigiForm: DigiForm, Profile: Profile };
//# sourceMappingURL=digi-profile.js.map